/**
 * Subscription API client for self-service billing.
 */

import { apiService } from './api';

const BASE = '/subscription';

export const subscriptionApi = {
  // Plans (public)
  listPlans: async () => {
    const r = await apiService.get(`${BASE}/plans`);
    return r.data;
  },

  getPlan: async (planId) => {
    const r = await apiService.get(`${BASE}/plans/${planId}`);
    return r.data;
  },

  // Current subscription
  getCurrent: async () => {
    const r = await apiService.get(`${BASE}/current`);
    return r.data;
  },

  // Activate after PayPal approval
  activate: async ({ paypalSubscriptionId, planId, billingCycle, paymentMethod, cardLast4 }) => {
    const r = await apiService.post(`${BASE}/activate`, {
      paypalSubscriptionId,
      planId,
      billingCycle,
      paymentMethod,
      cardLast4,
    });
    return r.data;
  },

  // Cancel
  cancel: async () => {
    const r = await apiService.post(`${BASE}/cancel`);
    return r.data;
  },

  // Usage
  getUsage: async () => {
    const r = await apiService.get(`${BASE}/usage`);
    return r.data;
  },

  // Payment history
  listPayments: async () => {
    const r = await apiService.get(`${BASE}/payments`);
    return r.data;
  },

  // PayPal config (client ID for SDK)
  getPaypalConfig: async () => {
    const r = await apiService.get(`${BASE}/paypal-config`);
    return r.data;
  },
};
